import React, { useEffect, useState } from 'react';
import "./style.sass";
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { InputTypeAndroid } from 'components/Forms/InputType';
import { useForm } from 'react-hook-form';
import { decodeStorage } from 'functions/storageBase64';
import { useStorage64 } from 'hooks/useStorageBase64';


export function DatosRecabadosIncode(props) {

    const {onSuccess} = props;

    const profileData = decodeStorage('profileData');

    const EXTERNO = decodeStorage('EXTERNO');

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Telmex  Credit-Page');
        window.ineum('meta', 'portal', 'Credito CS');
    }, [])

    const [inputNombre, setInputNombre] = useState();
    const [inputApellidoP, setInputApellidoP] = useState();
    const [inputApellidoM, setInputApellidoM] = useState();
    const [inputFechaNacimiento, setInputFechaNacimiento] = useState();
    const [inputLugarNacimiento, setInputLugarNacimiento] = useState();
    const [inputCurp, setInputCurp] = useState();

    const datosPersonalesStorage = decodeStorage("infoPersonalStorageIncode");
    const [datosPersonales, setDatosPersonales] = useState(datosPersonalesStorage);
    const telefonoOTPStorage = decodeStorage('telefonoOTPStorage');

    const [, setInfoPersonalRecabadaStorage] = useStorage64('infoPersonalRecabadaStorage', '');

    const [genero, setGenero] = useState(false);

    useEffect(() => {
        if(datosPersonales){
            setGenero(datosPersonales?.gender);
        }
      }, [datosPersonales]);

    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: {
            nombre: datosPersonales?.name?.firstName,
            apellidoP: datosPersonales?.name?.paternalLastName,
            apellidoM: datosPersonales?.name?.maternalLastName,
            fechaNacimiento: datosPersonales?.birthDate,
            lugarNacimiento: datosPersonales?.addresFields?.state,
            curp: datosPersonales?.curp,
            sexo: datosPersonales?.gender
        }
    })

    const valNombre = {
        required: 'Campo obligatorio',
        minLength: {
            value: 3,
            message: 'El nombre al menos debe de contener 3 carácteres'
        },
        maxLength: {
            value: 20,
            message: 'El nombre debe contener un máximo de 20 carácteres'
        }
    }
    const valApellidoP = {
        required: 'Campo obligatorio',
        maxLength: {
            value: 20,
            message: 'El apellido paterno debe contener un máximo de 20 carácteres'
        }
    }

    const valApellidoM = {
        required: 'Campo obligatorio',
        maxLength: {
            value: 20,
            message: 'El apellido materno debe contener un máximo de 20 carácteres'
        }
    }

    const valFechaNacimiento = {
        required: 'Campo obligatorio',
    }

    const valLugarNacimiento = {
        required: 'Campo obligatorio',
    }

    const valCurp = {
        required: 'Campo obligatorio',
        minLength: {
            value: 12,
            message: 'Faltan carácteres, Debe ser de al menos 12 carácteres'
        },
        maxLength: {
            value: 18,
            message: 'Debe contener máximo 18 carácteres'
        }
    }

    const valSexo = {
        required: 'Campo obligatorio',
    };

    const seleccionarGenero = (e) => {
        setGenero(e.target.value);
    }

     const handleInformacionIne = data => {
        
        console.log("data form",data);

        setInfoPersonalRecabadaStorage({
            "externalId": `${profileData?.idClaro}`,
            "Tienda": "00576",
            "Telefono": telefonoOTPStorage?.telefono,
            "Email": profileData?.correo,
            "Nombre": data.nombre,
            "APaterno": data.apellidoP,
            "AMaterno": data.apellidoM,
            "FechaNacimiento": data.fechaNacimiento,
            "LugarNacimiento": data.lugarNacimiento,
            "Curp": data.curp,
            "Genero": data.sexo
        })

        onSuccess();

    }

    

    //useEffect(() => {
    //    if (returnForm === true) {
    //        setInfoPersonalStorage(datos);
    //        SetReturnForm(false);
    //        nextPage(2);
    //    }
    //}, [returnForm])

    const resetErrors = (value) => {
        let inputId = document.querySelector(`#${value} ~ .error`)
        if (inputId) {
            let valu = value
            clearErrors(valu)
            // reset({
            //     titulo: datosPersonales.titulo,
            //     numero: datosPersonales.numero,
            //     Contrasena: datosPersonales.APaterno,
            //     apellidoM: datosPersonales.AMaterno,
            //     correo: datosPersonales.Email,
            //     telefono: datosPersonales.Telefono
            // });
        }
    }



    return (
        <>
            <div className="modalCredito full datosRecabados">
                <div className="contentModal">
                {
                    EXTERNO ? null : <HeaderMobileCredito title="Solicitud de Crédito Claroshop" type="back" />
                }
                    <div className="contenedorGeneral top0">
                        <div className="boxSolicitud">
                        <form onSubmit={handleSubmit(handleInformacionIne)} className="formularioSolicitudMobile">
                            <div className="tituloFormulariosMobile">
                                <p>Estos son los datos recabados, asegúrate que sean correctos</p>
                            </div>
                                <>
                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            name="nombre"
                                            id="nombre"
                                            placeholder="Nombre (s)"
                                            refs={register(valNombre)}
                                            className="desktopInput"
                                            autocomplete='name'
                                            setNumero={setInputNombre}
                                            numero={inputNombre}
                                            // value={inputNombre}
                                            errorMessage={errors.nombre && errors.nombre.message}
                                            pattern={'textOnly'}
                                            maxLength={20}
                                            click={() => resetErrors('nombre')}
                                            readonly="readonly"
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            name="apellidoP"
                                            id="apellidoP"
                                            placeholder="Apellido Paterno"
                                            refs={register(valApellidoP)}
                                            className="desktopInput"
                                            setNumero={setInputApellidoP}
                                            numero={inputApellidoP}
                                            // value={inputApellidoP}
                                            errorMessage={errors.apellidoP && errors.apellidoP.message}
                                            pattern={'textOnly'}
                                            maxLength={20}
                                            click={() => resetErrors('apellidoP')}
                                            readonly="readonly"
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            name="apellidoM"
                                            id="apellidoM"
                                            placeholder="Apellido Materno"
                                            refs={register(valApellidoM)}
                                            className="desktopInput"
                                            setNumero={setInputApellidoM}
                                            numero={inputApellidoM}
                                            // value={inputApellidoM}
                                            errorMessage={errors.apellidoM && errors.apellidoM.message}
                                            pattern={'textOnly'}
                                            maxLength={20}
                                            click={() => resetErrors('apellidoM')}
                                            readonly="readonly"
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            name="fechaNacimiento"
                                            id="fechaNacimiento"
                                            placeholder="Fecha de nacimiento"
                                            refs={register(valFechaNacimiento)}
                                            className="desktopInput"
                                            setNumero={setInputFechaNacimiento}
                                            numero={inputFechaNacimiento}
                                            // value={inputFechaNacimiento}
                                            errorMessage={errors.fechaNacimiento && errors.fechaNacimiento.message}
                                            pattern={'textOnly'}
                                            maxLength={20}
                                            click={() => resetErrors('fechaNacimiento')}
                                            readonly="readonly"
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            name="lugarNacimiento"
                                            id="lugarNacimiento"
                                            placeholder="Lugar de nacimiento"
                                            refs={register(valLugarNacimiento)}
                                            className="desktopInput"
                                            setNumero={setInputLugarNacimiento}
                                            numero={inputLugarNacimiento}
                                            // value={inputLugarNacimientoo}
                                            errorMessage={errors.lugarNacimiento && errors.lugarNacimiento.message}
                                            pattern={'textOnly'}
                                            maxLength={20}
                                            click={() => resetErrors('lugarNacimiento')}
                                            readonly="readonly"
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            name="curp"
                                            id="curp"
                                            placeholder="CURP"
                                            refs={register(valCurp)}
                                            className="desktopInput"
                                            setNumero={setInputCurp}
                                            numero={inputCurp}
                                            // value={inputCurp}
                                            errorMessage={errors.curp && errors.curp.message}
                                            pattern={'textOnly'}
                                            maxLength={20}
                                            click={() => resetErrors('curp')}
                                            readonly="readonly"
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <div className="boxGeneroM">
                                            <p>Genero:</p>

                                            <ul className={genero === false && errors.sexo && errors.sexo.message ? "ulGeneroMobile conError" : "ulGeneroMobile"} onChange={seleccionarGenero}>
                                                <li id="femenino">
                                                    <input className="radio" id="f" type="radio" value="F" name="sexo" checked={genero === "F" ? true : false} ref={register(valSexo)} />
                                                    <label name="f" htmlFor="f"> Mujer </label>
                                                </li>
                                                <li id="masculino">
                                                    <input className="radio" id="m" type="radio" value="M" name="sexo" checked={genero === "M" ? true : false} ref={register(valSexo)} />
                                                    <label name="m" htmlFor="m"> Hombre </label>
                                                </li>
                                            </ul>

                                            {genero === false && errors.sexo && errors.sexo.message
                                                ? <div className="error">Campo obligatorio</div>
                                                : null
                                            }
                                        </div>
                                    </div>

                                </>
                            
                            <div className="boxBtnSolicitar marginBottom30">
                                <button className="btnSolicitar"> Continuar</button>
                            </div>
                        </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}